module.exports = __webpack_public_path__ + "img/feature_buy_th.1dc50d9a.png";